import {IAnalysisPackage, ISecurityDropDown} from "./irb-rebalance.model";
import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {IrbRebalanceEvents} from "@irb/irb-common/events";
import {AppService} from "@irb/app.service";

@Injectable({ providedIn: "root" })
export class RebalanceService {
  constructor(private _http: HttpClient, private as: AppService) {}

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
      Expires: "Sat, 01 Jan 2000 00:00:00 GMT",
    }),
  };

    rebalanceSource: string;

  getRebalanceTypeListObject(isTlhWsaEnabled: boolean) {
    const rebalanceTypeList: any = [
      {
        label: "Full rebalance",
        value: "1",
        disableSubmit: false,
        disableEditParameters: false,
        glabel: "Full rebalance",
        gvalue: "FULL_REBALANCE",
        groupSeparater: true,
        disableContinue: false,
      },
      {
        label: "Generate and/or invest cash",
        value: "2",
        disableSubmit: false,
        disableEditParameters: false,
        glabel: "Generate invest",
        gvalue: "GENERATE_INVEST",
        disableContinue: false,
      },
      {
        label: "Generate cash only",
        value: "3",
        disableSubmit: false,
        disableEditParameters: false,
        glabel: "Generate cash only",
        gvalue: "GENERATE_CASH",
        disableContinue: false,
      },
      {
        label: "Invest cash only",
        value: "4",
        disableSubmit: false,
        disableEditParameters: false,
        glabel: "Manage cash only",
        gvalue: "INVEST_CASH",
        groupSeparater: true,
        disableContinue: false,
      },
      {
        label: "Adjust securities",
        value: "5",
        disableSubmit: true,
        disableEditParameters: true,
        glabel: "Directed trading",
        gvalue: "ADJUST_SECURITIES",
        disableContinue: true,
      },
      {
        label: "Tax Loss Harvest",
        value: "6",
        disableSubmit: true,
        disableEditParameters: true,
        glabel: "Directed trading",
        gvalue: "HARVEST_TAX_LOSS",
        disableContinue: true
      },
      {
        label: "Replace securities",
        value: "8",
        disableSubmit: true,
        disableEditParameters: true,
        glabel: "Directed trading",
        gvalue: "REPLACE_SECURITIES",
        disableContinue: true,
      },
      {
        label: "Manual adjustment",
        value: "9",
        disableSubmit: false,
        disableEditParameters: true,
        glabel: "Directed trading",
        gvalue: "MANUAL_ADJUSTMENT",
        disableContinue: false,
      },
      {
        label: "Covered call",
        value: "10",
        disableSubmit: true,
        disableEditParameters: true,
        glabel: "Directed trading",
        gvalue: "COVERED_CALL",
        disableContinue: true,
      },
    ];
    const ENABLE_TLH_FR = this.as.getItem('IRB_APP_CONFIG')?.featureFlags.ENABLE_TLH_FR || false;
    if (isTlhWsaEnabled && ENABLE_TLH_FR) {
      const itemTLH_Full = {
        label: "Tax Loss Harvest and Full Rebalance",
        value: "7",
        disableSubmit: false,
        disableEditParameters: false,
        glabel: "TLH FULL REBALANCE",
        gvalue: "TLH_FULL_REBALANCE",
        disableContinue: false,
        customToolTipWhenDisabled: 'Configure tax loss harvest settings from iRebal settings before selecting this option.'
      };
      rebalanceTypeList.splice(6, 0, itemTLH_Full);
    }
    return rebalanceTypeList;
  }

  getRebalanceTypeEvent(params: any) {
    let eventName: string;
    let statusRebalance: any;
        if(params.data.status === "Scheduled" || params.data.status === "Complete" || params.data.status === "Expired"){
            statusRebalance = 'Scheduled';
        }else{
          if(params.data.source === "portfolioDialog"){
            statusRebalance = 'rebalancePortfolioDialog';
          }
          if(params.data.source === "viewResultSummary"){
            statusRebalance = 'resultSummary';
          }
        }
        if(params.data.analysisType === "Tax Loss Harvest" || params.data.analysisType === "Harvest tax losses" || params.data.analysisType === "Harvest") {
          eventName = IrbRebalanceEvents.SHOW_HARVEST_TAX_LOSS_REBALANCE;
          }
          if(params.data.analysisType === "Fully rebalance securities & cash" || params.data.analysisType === "Full rebalance" || params.data.analysisType === "Full Reb") {
            eventName = IrbRebalanceEvents.SHOW_EDIT_CREATE_REBALANCE;
          }
          if(params.data.analysisType === "Generate and/or invest cash" || params.data.analysisType === "Generate / invest cash"
              || params.data.analysisType === "Cash to Target") {
            eventName = IrbRebalanceEvents.SHOW_GENERATE_INVEST_CASH_REBALANCE;
          }
          if(params.data.analysisType === "Invest cash only" || params.data.analysisType === "Invest Cash") {
            eventName = IrbRebalanceEvents.SHOW_INVEST_CASH_REBALANCE;
          }
          if(params.data.analysisType === "Generate cash only" || params.data.analysisType === "Gen Cash") {
            eventName = IrbRebalanceEvents.SHOW_GENERATE_CASH_REBALANCE;
          }
          if(params.data.analysisType === "Replace securities" || params.data.analysisType === "Replace") {
            eventName = IrbRebalanceEvents.SHOW_REPLACE_SECURITIES_REBALANCE;
          }
          if(params.data.analysisType === "Adjust securities" || params.data.analysisType === "Single Adj") {
           eventName = IrbRebalanceEvents.SHOW_ADJUST_SECURITIES_REBALANCE;
          }
          if(params.data.analysisType === "Covered call" || params.data.analysisType === "Roll covered call"
          || params.data.analysisType === "Covered Call Purchase" || params.data.analysisType === "Covered Call Close"
          || params.data.analysisType === "Covered Call Open") {
            eventName = IrbRebalanceEvents.SHOW_EDIT_COVEREDCALL_REBALANCE;
          }
          if(params.data.analysisType === "Manual adjustment" || params.data.analysisType === "Manual Adj") {
            eventName = IrbRebalanceEvents.MANUAL_ADJUSTMENT_REBALANCE;
          }
          if (params.data.analysisType === "Tax Loss Harvest and Full Rebalance") {
            eventName = IrbRebalanceEvents.SHOW_TLH_FULL_REBALANCE;
          }

          if(eventName) {
            let eventData: any = {
              fullscreen: true,
              analysisId: params.data.analysisId,
              source: statusRebalance,
              ignoreUnsavedChanges: params.ignoreUnsavedChanges,
              navigationSource: params.data.navigationSource,
              rebalanceParams: params.rebalanceParams
            };
            if (params.data.slot) {
              eventData.slot = params.data.slot;
            }
            if (params.modelId) {
              eventData.modelId = params.modelId;
            }
            if (params.modelName) {
              eventData.modelName = params.modelName;
            }
            if (params.smartFilterDto) {
              eventData.smartFilterDto = params.smartFilterDto;
            }
              this.setRebalanceSource(statusRebalance);
            this.as.fireEvent(eventName, eventData);
        } else {
            //console.error("Event not found for " + params.data.analysisType);
        }
   
  }

  getCoveredCallTradeTypes() {
    return this._http.get("/irebalone/rebalance-portfolios/covered-call-trades-drop-down", this.httpOptions);
  }

  getEquitySecuritiesDropDown() {
    return this._http.get("/irebalone/rebalance-portfolios/securities-drop-down/EQ", this.httpOptions);
  }

  saveRebalance(analysisPackage: IAnalysisPackage) {
    return this._http.post("/irebalone/rebalance-portfolios/save-rebalance", JSON.stringify(analysisPackage), this.httpOptions);
  }

  submitPortfoliosToQueue(map: any) {
    return this._http.post("/irebalone/rebalance-portfolios/submit-portfolios-to-queue", JSON.stringify(map), this.httpOptions);
  }

  getHistoryDetail(analysisId: any) {
    return this._http.get("/irebalone/rebalance-portfolios/get-history-detail/" + analysisId, this.httpOptions);
  }
  getRebalanceDetail(analysisId: any) {
    return this._http.get("/irebalone/rebalance-portfolios/get-rebalance-detail/" + analysisId, this.httpOptions);
  }

  getSecuritiesDropDown(): Observable<ISecurityDropDown> {
    return this._http.get<ISecurityDropDown>("/irebalone/rebalance-portfolios/securities-drop-down/ALL", this.httpOptions);
  }

    getRebalanceSource() {
        return this.rebalanceSource;
    }

    setRebalanceSource(src: string) {
        this.rebalanceSource = src;
    }
}
